import React from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, Badge, Avatar, Tooltip, Tag } from 'antd';
import { UserOutlined, LogoutOutlined, BellOutlined, QuestionCircleOutlined, ShieldOutlined } from '@ant-design/icons';
import useAuthStore from '../store/authStore';
import { usePermissions } from '../hooks/usePermissions';

const NavBar = ({ handlogout }) => {
    const { user } = useAuthStore();
    const { roleName, isAdmin, isAdministrativo, isAuditor, isCoordinador } = usePermissions();
    
    // Configurar color y texto del rol
    const getRoleConfig = () => {
        if (isAdmin()) {
            return { color: 'red', text: 'Administrador', icon: '👑' };
        }
        if (isAdministrativo()) {
            return { color: 'blue', text: 'Administrativo', icon: '⚙️' };
        }
        if (isAuditor()) {
            return { color: 'green', text: 'Auditor', icon: '👁️' };
        }
        if (isCoordinador()) {
            return { color: 'orange', text: 'Coordinador', icon: '📋' };
        }
        return { color: 'default', text: roleName || 'Usuario', icon: '👤' };
    };

    const roleConfig = getRoleConfig();
    
    const items = [
        {
            key: 'profile',
            label: <Link to="/perfil">Mi Perfil</Link>,
            icon: <UserOutlined />,
        },
        {
            key: 'role-info',
            label: (
                <div className="px-2 py-1">
                    <div className="text-xs text-gray-500">Rol actual:</div>
                    <Tag color={roleConfig.color} className="mt-1">
                        {roleConfig.icon} {roleConfig.text}
                    </Tag>
                </div>
            ),
            disabled: true,
        },
        {
            type: 'divider',
        },
        {
            key: 'logout',
            label: <span onClick={handlogout}>Cerrar Sesión</span>,
            icon: <LogoutOutlined />,
            danger: true,
        },
    ];

    return (
        <div className='flex bg-gradient-to-r from-blue-900 to-blue-700 items-center justify-between px-5 py-3 shadow-md site-navbar'>
            <div className="flex items-center">
                <h3 className="font-semibold text-white">
                    Software de Novedades Administrativas y Docentes - UDI
                </h3>
            </div>

            <div className="flex items-center gap-6">
                {/* <Tooltip title="Centro de ayuda">
                    <QuestionCircleOutlined className="text-white text-lg cursor-pointer hover:text-blue-200 transition-all" />
                </Tooltip>
                
                <Tooltip title="Notificaciones">
                    <Badge count={3} size="small">
                        <BellOutlined className="text-white text-lg cursor-pointer hover:text-blue-200 transition-all" />
                    </Badge>
                </Tooltip> */}                <div className="flex items-center gap-3 border-l border-blue-400 pl-6">
                    <div className="text-right">
                        <div className="text-white text-sm font-medium">
                            {user?.name || 'Usuario'}
                        </div>
                        <Tag 
                            color={roleConfig.color} 
                            size="small"
                            className="mt-1"
                        >
                            {roleConfig.icon} {roleConfig.text}
                        </Tag>
                    </div>
                    <Dropdown menu={{ items }} placement="bottomRight" arrow>
                        <Avatar
                            style={{ 
                                backgroundColor: '#1890ff',
                                cursor: 'pointer',
                                border: '2px solid white'
                            }} 
                            icon={<UserOutlined />}
                            className="cursor-pointer"
                        />
                    </Dropdown>
                </div>
            </div>
        </div>
    );
};

export default NavBar;